import { Input as BaseInput } from "../../../ui/input";
import { InputProps } from "../types";
import { withFormField } from "./withFormField";

import React from "react";

// Create a base input component that forwards the ref
const BaseInputComponent = React.forwardRef<HTMLInputElement, InputProps>(
  (props, ref) => <BaseInput {...props} ref={ref} />,
);

// Wrap the base input component with the form field HOC
export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (props, ref) =>
    withFormField<InputProps>(BaseInputComponent)({ ...props, ref }),
);
